import React from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { Rating, Image, ActionIcon } from "components";
import ProductImage from "tests/assets/5.png";
import MemeTMerchImage from "assets/MemeTMerch.png";
import { displayCurrencyAmount, displayDriveImage } from "utils";
import "./index.css";
import "./mobile.css";
import "./tablet.css";

const ProductCard = ({ product, handleAddToWishlist }) => {
  const navigate = useNavigate();
  const {
    _id,
    title,
    contentLanguage,
    isMemeTMerch,
    price,
    discount,
    discountedPrice,
    rating,
    ratingsCount,
    inventoryImages,
    inWishlist,
  } = product;
  return (
    <div
      className="div__productCard"
      onClick={() => navigate(`/product/${_id}`)}
    >
      <Image
        imageURL={
          (!_.isEmpty(inventoryImages) &&
            displayDriveImage(_.first(inventoryImages))) ||
          ProductImage
        }
        className="div__productCard-image"
      />
      <ActionIcon
        type={"favorite"}
        iconClassName={inWishlist ? "iconWishlistSelected" : "iconWishlist"}
        onClick={handleAddToWishlist}
      />
      <div className="div__productCard__details">
        <div className="div__productCard-title">
          <div>
            <p className="productTitle">{title}</p>
            <p className="lblLanguage">{contentLanguage}</p>
          </div>
          <div className="div__productCard-price">
            <p className="productPrice">
              {displayCurrencyAmount(discount ? discountedPrice : price)}
            </p>
            {discount > 0 && (
              <p className="productDiscountedPrice">
                {displayCurrencyAmount(price)}
                <span className="productDiscount">{`(${discount}%)`}</span>
              </p>
            )}
          </div>
        </div>

        <div className="div__productCard-footer">
          <div className="div__productCard-rating">
            <Rating value={rating} readOnly />
            <p className="ratingsCount">({ratingsCount})</p>
          </div>
          {isMemeTMerch && (
            <Image
              imageURL={MemeTMerchImage}
              className="div__productCard-memeTMerch"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
